import { UPDATE_USER_STATUS, UPDATE_USER_STATUS_SUCCESS, UPDATE_USER_STATUS_FAILURE } from "../actionTypes";

export const updateUserStatus = (payload) => ({
  type: UPDATE_USER_STATUS,
  payload,
});

export const updateUserStatusSuccess = () => ({
  type: UPDATE_USER_STATUS_SUCCESS,
});

export const updateUserStatusFailure = () => ({
  type: UPDATE_USER_STATUS_FAILURE,
});
